export const ExcelHeader = {
  Drawer: 'drawer',
  Pn: 'p/n',
  PnAlt: 'pn',
  Quantity: 'quantity',
} as const
